import React, { createContext, useContext, useState } from "react";

const StoryContext = createContext();

export const StoryProvider = ({ children }) => {
  // ---------------- STORY DETAILS  ----------------
  const [storyTitle, setStoryTitle] = useState("");
  const [storyDescription, setStoryDescription] = useState("");
  const [storyCategory, setStoryCategory] = useState("");
  const [storyCoverImg, setStoryCoverImg] = useState(null);
  const [storyDifficulty, setStoryDifficulty] = useState(3);

  // ---------------- STORY CHARACTERS  ----------------
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [deletedCharacters, setDeletedCharacters] = useState([]);

  // ---------------- STORY SENTENCES  ----------------
  const [selectedSentences, setSelectedSentences] = useState([]);
  const [deletedSentences, setDeletedSentences] = useState([]);

  // ---------------- STORY ASSETS  ----------------
  const [deletedAssets, setDeletedAssets] = useState([]);
  const [selectedAssets, setSelectedAssets] = useState([ ]);

  /*
    { name: "", png: null, sprites: [], backgrounds: [], soundscape: [], music: [], sfx: [], type: 0, },
    { name: "", png: null, sprites: [], backgrounds: [], soundscape: [], music: [], sfx: [], type: 2, },
    { name: "", png: null, sprites: [], backgrounds: [], soundscape: [], music: [], sfx: [], type: 3, },
    { name: "", png: null, sprites: [], backgrounds: [], soundscape: [], music: [], sfx: [], type: 4, },
    { name: "", png: null, sprites: [], backgrounds: [], soundscape: [], music: [], sfx: [], type: 5, },
 */


  // ---------------- STORY GENERICS  ----------------
  const [storyId, setStoryId] = useState(null);
  const [mode, setMode] = useState("create"); // create | edit
  const [publishClicked, setPublishClicked] = useState(false);

  return (
    <StoryContext.Provider
      value={{
        storyTitle,
        setStoryTitle,

        storyDescription,
        setStoryDescription,

        storyCategory,
        setStoryCategory,

        storyCoverImg,
        setStoryCoverImg,

        storyDifficulty,
        setStoryDifficulty,

        storyId,
        setStoryId,

        selectedCharacters,
        setSelectedCharacters,
        deletedCharacters,
        setDeletedCharacters,

        selectedSentences,
        setSelectedSentences,
        deletedSentences,
        setDeletedSentences,

        deletedAssets, setDeletedAssets,
        selectedAssets, setSelectedAssets,

        mode,
        setMode,       

        publishClicked,
        setPublishClicked,
      }}
    >
      {children}
    </StoryContext.Provider>
  );
};

export const useStoryContext = () => useContext(StoryContext);